// store/authStore.js
import { create } from "zustand";
import { getBannerData } from "../api/home";
import { getAboutUs } from "../api/aboutus";

export const useAboutUsStore = create((set, get) => ({
    loading: true,
    banner: null,
    story: null,
    promise: null,
    mission: null,
    founder: null,

    getBanner: async () => {
        try {
            set({ loading: true })
            const res = await getBannerData('aboutUs')
            set({ loading: false, banner: res })
            return res
        } catch (error) {
            console.log("Error in checkAuth:", error);
            set({ authUser: null, hasTriedAuth: true });
            return false;
        } finally {
            set({ isCheckingAuth: false, hasTriedAuth: true });
        }
    },
    getAbout: async () => {
        try {
            set({ loading: true })
            const res = await getAboutUs()
            console.log("About Us Data:", res);
            set({ loading: false, story: res?.story, mission: res?.mission, founder: res?.founder, promise: res?.promise })
            return res
        } catch (error) {
            console.log("Error in checkAuth:", error);
            set({ authUser: null, hasTriedAuth: true });
            return false;
        } finally {
            set({ isCheckingAuth: false, hasTriedAuth: true });
        }
    }

}));
